module.exports = __webpack_public_path__ + "static/media/link-h.d6dced71.svg";